import { create } from 'zustand';

export const useIsOpenAIAssistant = create((set) => ({
  open: true,
  setIsOpen: (isOpen: boolean) => set(() => ({ open: isOpen }))
}));

export const useShowShareModalLoader = create((set) => ({
  shareFileLoader: false,
  setShareFileLoader: (shareFileLoader: boolean) =>
    set(() => ({ shareFileLoader: shareFileLoader }))
}));

export const useCurrentScreenWidth = create((set) => ({
  screen: 0,
  setScreen: (number: number) => set(() => ({ screen: number }))
}));

export const useMajorReportsCheckboxView = create((set) => ({
  checkbox: [],
  setCheckbox: (data: any) => set(() => ({ checkbox: data }))
}));

export const useMajorSignalsCheckboxView = create((set) => ({
  checkbox: [],
  setCheckbox: (data: any) => set(() => ({ checkbox: data }))
}));

export const useMajorCheckbox360View = create((set) => ({
  checkbox: [],
  setCheckbox: (data: any) => set(() => ({ checkbox: data }))
}));

export const useTextModalFilters = create((set) => ({
  text: '',
  setText: (text: string) => set(() => ({ text: text }))
}));

export const useTextModalFiltersHasChanged = create((set) => ({
  hasChanged: false,
  setHasChanged: (checked: boolean) => set(() => ({ hasChanged: checked }))
}));

export const useComboxFilterValues = create((set) => ({
  values: [
    {
      name: 'contains',
      option: 'first'
    }
  ],
  setValues: (data: any) => set(() => ({ values: data }))
}));

export const useFirstDateFromModalFilters = create((set) => ({
  date: '',
  setDate: (text: string) => set(() => ({ date: text }))
}));

export const useFirstDateToModalFilters = create((set) => ({
  date: '',
  setDate: (text: string) => set(() => ({ date: text }))
}));

export const useSecondDateFromModalFilters = create((set) => ({
  date: '',
  setDate: (text: string) => set(() => ({ date: text }))
}));

export const useSecondDateToModalFilters = create((set) => ({
  date: '',
  setDate: (text: string) => set(() => ({ date: text }))
}));

export const useSortMenuReportsValues = create((set) => ({
  sortData: [],
  setSortData: (data: any) => set(() => ({ sortData: data }))
}));

export const useSortMenuSignalsValues = create((set) => ({
  sortData: [],
  setSortData: (data: any) => set(() => ({ sortData: data }))
}));

export const useSortMenuCorrelationValues = create((set) => ({
  sortData: [],
  setSortData: (data: any) => set(() => ({ sortData: data }))
}));

export const useSortMenuCohortsValues = create((set) => ({
  sortData: [],
  setSortData: (data: any) => set(() => ({ sortData: data }))
}));

export const useForceReportsShowLess = create((set) => ({
  force: [],
  setForce: (isForced: boolean) => set(() => ({ force: isForced }))
}));

export const useForceSignalsShowLess = create((set) => ({
  force: [],
  setForce: (isForced: boolean) => set(() => ({ force: isForced }))
}));

export const useForceCohortsShowLess = create((set) => ({
  force: [],
  setForce: (isForced: boolean) => set(() => ({ force: isForced }))
}));

export const useForceReportsShowMore = create((set) => ({
  force: [],
  setForce: (isForced: boolean) => set(() => ({ force: isForced }))
}));

export const useForceSignalsShowMore = create((set) => ({
  force: [],
  setForce: (isForced: boolean) => set(() => ({ force: isForced }))
}));

export const useForceCohortsShowMore = create((set) => ({
  force: [],
  setForce: (isForced: boolean) => set(() => ({ force: isForced }))
}));

export const useForceShowMoreUpdated = create((set) => ({
  updated: true,
  setUpdated: (update: boolean) => set(() => ({ updated: update }))
}));

export const useClearSelectionReports = create((set) => ({
  clear: false,
  setIsClear: (isCleared: boolean) => set(() => ({ clear: isCleared }))
}));

export const useClearSelectionCohorts = create((set) => ({
  clear: false,
  setIsClear: (isCleared: boolean) => set(() => ({ clear: isCleared }))
}));

export const useClearSelectionCorrelation = create((set) => ({
  clear: false,
  setIsClear: (isCleared: boolean) => set(() => ({ clear: isCleared }))
}));

export const useClearSelectionSignals = create((set) => ({
  clear: false,
  setIsClear: (isCleared: boolean) => set(() => ({ clear: isCleared }))
}));

export const useSearchTextStoreReports = create((set) => ({
  text: [],
  setText: (text: string) => set(() => ({ text: text }))
}));

export const useForceCorrelationShowMore = create((set) => ({
  force: [],
  setForce: (isForced: boolean) => set(() => ({ force: isForced }))
}));

export const useForceCorrelationShowLess = create((set) => ({
  force: [],
  setForce: (isForced: boolean) => set(() => ({ force: isForced }))
}));

export const useMajorCorrelationCheckboxView = create((set) => ({
  checkbox: [],
  setCheckbox: (data: any) => set(() => ({ checkbox: data }))
}));

export const useAccountHasPlanPaid = create((set) => ({
  accountPaid: false,
  setAccountPaid: (paid: boolean) => set(() => ({ accountPaid: paid }))
}));

export const useAccountHasLillyPaid = create((set) => ({
  accountPaid: false,
  setAccountPaid: (paid: boolean) => set(() => ({ accountPaid: paid }))
}));

export const useShowsDataUpdateModal = create((set) => ({
  show: false,
  setShow: (show: boolean) => set(() => ({ show: show }))
}));

export const useChecksProjectDataUpdateModal = create((set) => ({
  checks: null,
  setChecks: (checks: any) => set(() => ({ checks: checks }))
}));

export const useFinishProjectDataUpdateModal = create((set) => ({
  checks: false,
  setChecks: (checks: boolean) => set(() => ({ checks: checks }))
}));

export const useAccountHasTextAnalyzerPaid = create((set) => ({
  accountPaid: false,
  setAccountPaid: (paid: boolean) => set(() => ({ accountPaid: paid }))
}));

export const useChecksPages = create((set) => ({
  onlyOnePage: [],
  setOnlyOnePage: (onepage: any) => set(() => ({ onlyOnePage: onepage }))
}));

export const useChecksLastPage = create((set) => ({
  isLastPage: [],
  setIsLastPage: (page: any) => set(() => ({ isLastPage: page }))
}));

export const useValueSearchTextBox = create((set) => ({
  value: null,
  setValue: (value: string) => set(() => ({ value: value }))
}));

export const useSearchTextboxVisible = create((set) => ({
  columns: [],
  setColumns: (page: any) => set(() => ({ columns: page }))
}));

export const useEmailsShared = create((set) => ({
  emails: [],
  setEmails: (emails: any) => set(() => ({ emails: emails }))
}));

export const useShowDownloadPopUp = create((set) => ({
  show: false,
  setShow: (show: boolean) => set(() => ({ show: show }))
}));

export const useDownloadOptions = create((set) => ({
  option: '',
  setOption: (option: string) => set(() => ({ option: option }))
}));

export const useExpandableMenuWidthValue = create((set) => ({
  value: 275,
  setValue: (value: number) => set(() => ({ value: value }))
}));

export const useExpandable360MenuWidthValue = create((set) => ({
  value: 275,
  setValue: (value: number) => set(() => ({ value: value }))
}));

export const useIsExpanding360Menu = create((set) => ({
  expanding: false,
  setIsExpanding: (value: boolean) => set(() => ({ expanding: value }))
}));

export const useSaveChangesOff = create((set) => ({
  saveChangesOff: true,
  setSaveChangesOff: (show: boolean) => set(() => ({ saveChangesOff: show }))
}));

export const useDragActivated = create((set) => ({
  dragged: false,
  setDragged: (show: boolean) => set(() => ({ dragged: show }))
}));

export const useOpenUpUpgradeModal = create((set) => ({
  open: false,
  setOpen: (open: boolean) => set(() => ({ open: open }))
}));

export const useShowsLoaderAIExplainer = create((set) => ({
  show: false,
  setShow: (show: boolean) => set(() => ({ show: show }))
}));

export const useRefreshAIExplainer = create((set) => ({
  refresh: false,
  setRefresh: (refresh: boolean) => set(() => ({ refresh: refresh }))
}));

export const useFileSelected = create((set) => ({
  fileData: false,
  setFileData: (fileData: any) => set(() => ({ fileData: fileData }))
}));

export const useAIQuestion = create((set) => ({
  question: '',
  setQuestion: (question: string) => set(() => ({ question: question }))
}));

interface MyLoaderMenuStore {
  showLoader: any;
  setShowLoader: (data: any) => void;
  clearMyLoader: () => void;
}

export const useLoaderMenuStore = create<MyLoaderMenuStore>((set) => ({
  showLoader: [],
  setShowLoader: (data) => set(() => ({ showLoader: data })),
  clearMyLoader: () => set(() => ({ showLoader: null }))
}));
